var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { FAR_CHEVRON_DOWN } from '../../../../const/iconProps';
import { CategoryIcon, ChevronIcon, MarketingPreferenceHeaderTitle, MarketingPreferenceHeaderTitleWrapper, MarketingPreferenceHeaderWrapper } from './subcomponents';
import { marketingPrivacySettingsCategories } from '../../config';
var MarketingPreferenceHeader = function (_a) {
    var _b;
    var categoryKey = _a.categoryKey, isAccordionExpanded = _a.isAccordionExpanded;
    var t = useTranslation().t;
    var icon = (_b = marketingPrivacySettingsCategories[categoryKey]) === null || _b === void 0 ? void 0 : _b.icon;
    var dataAttributes = isAccordionExpanded
        ? {
            arrowRotation: 180
        }
        : {
            arrowRotation: 0
        };
    var title = t("marketingPrivacySettingsTitle.".concat(categoryKey));
    return (_jsxs(MarketingPreferenceHeaderWrapper, __assign({ "data-test": "MarketingPreferenceHeader" }, { children: [_jsxs(MarketingPreferenceHeaderTitleWrapper, { children: [_jsx(CategoryIcon, { icon: icon, size: "lg" }), _jsx(MarketingPreferenceHeaderTitle, { children: title })] }), _jsx(ChevronIcon, { icon: FAR_CHEVRON_DOWN, size: "xs", transform: { rotate: dataAttributes.arrowRotation } })] })));
};
export default MarketingPreferenceHeader;
